import { useState } from 'react';
import '../Styles/branding.css';
import JoinModal from '../components/JoinModel';

function Branding() {
  const [isJoinOpen, setIsJoinOpen] = useState(false);

  return (
    <>
      {/* ===================================================
          SECTION 1: EMPLOYER BRANDING & RECOGNITION (SPLIT LEFT / RIGHT)
      =================================================== */}
      <section className="branding-hero">
        <div className="branding-hero-container">
          {/* LEFT — badge, heading, subtitle, button */}
          <div className="branding-hero-left">
            <span className="branding-hero-badge">Employer Branding &amp; Recognition</span>

            <h1 className="branding-hero-title">
              Elevating Employer Brands.<br />
              Celebrating{' '}
              <span className="branding-hero-title-highlight">Workplace Excellence.</span>
            </h1>

            <p className="branding-hero-subtitle">
              Employer Branding &amp; Recognition by Vanakkam HRD is dedicated to helping organizations build a strong employer reputation, attract top talent, and showcase their workplace culture. We create trusted platforms that recognize organizations committed to excellence in people practices, leadership, innovation, and employee experience.
            </p>

            <p className="branding-hero-subtitle">
              Through certifications, awards, leadership platforms, and employer branding initiatives, we enable organizations to enhance their credibility, strengthen their brand presence, and position themselves as employers of choice.
            </p>

            <button
              type="button"
              className="branding-hero-btn"
              onClick={() => setIsJoinOpen(true)}
            >
              Become a Member
              <img
                src="/assets/About_arrow_icon.png"
                alt="Arrow Icon"
                className="branding-arrow-icon"
              />
            </button>
          </div>

          {/* RIGHT — image */}
          <div className="branding-hero-right">
            <div className="branding-hero-img-wrap">
              <div className="branding-hero-img-accent"></div>
              <img
                src="/assets/Branding_img_1.png"
                alt="Team discussing employer branding strategy"
                className="branding-hero-img"
              />
            </div>
          </div>
        </div>
      </section>

      {/* ===================================================
          SECTION 2: OUR SERVICES
      =================================================== */}
      <section className="branding-services-section">
        <div className="branding-services-container">
          <h2 className="branding-services-heading">Our Services</h2>
          <div className="branding-services-underline"></div>

          <div className="branding-services-grid">
            <div className="branding-services-card">
              <div className="branding-services-icon">
                <img
                  src="/assets/Branding_icon_1.png"
                  alt="Employer Branding Solutions Icon"
                  className="branding-services-icon-img"
               
                />
              </div>
              <h3 className="branding-services-card-title">
                Employer Branding Solutions
              </h3>
              <p className="branding-services-card-desc">
                Build a compelling employer brand that attracts, engages, and retains top talent through strategic branding and visibility initiatives.
              </p>
            </div>

            <div className="branding-services-card">
              <div className="branding-services-icon">
                <img
                  src="/assets/Branding_icon_2.png"
                  alt="Workplace Certification Icon"
                  className="branding-services-icon-img"
               
                />
              </div>
              <h3 className="branding-services-card-title">
                Workplace Certification
              </h3>
              <p className="branding-services-card-desc">
                Gain industry recognition through credible workplace certification programs that validate your people-first culture and organizational excellence.
              </p>
            </div>

            <div className="branding-services-card">
              <div className="branding-services-icon">
                <img
                  src="/assets/Branding_icon_3.png"
                  alt="HR & Leadership Awards Icon"
                  className="branding-services-icon-img"
                  
                />
              </div>
              <h3 className="branding-services-card-title">
                HR &amp; Leadership Awards
              </h3>
              <p className="branding-services-card-desc">
                Celebrate outstanding HR leaders, organizations, and innovative workplace practices through prestigious recognition programs.
              </p>
            </div>

            <div className="branding-services-card">
              <div className="branding-services-icon">
                <img
                  src="/assets/Branding_icon_4.png"
                  alt="Employer Brand Campaigns Icon"
                  className="branding-services-icon-img"
                  
                />
              </div>
              <h3 className="branding-services-card-title">
                Employer Brand Campaigns
              </h3>
              <p className="branding-services-card-desc">
                Increase your brand visibility through digital campaigns, interviews, success stories, social media promotions, and featured articles.
              </p>
            </div>

            <div className="branding-services-card">
              <div className="branding-services-icon">
                <img
                  src="/assets/Branding_icon_5.png"
                  alt="Leadership Thought Leadership Icon"
                  className="branding-services-icon-img"
                  
                />
              </div>
              <h3 className="branding-services-card-title">
                Leadership Thought Leadership
              </h3>
              <p className="branding-services-card-desc">
                Position your HR leaders and executive experts through keynote speaking opportunities, panel discussions, podcasts, webinars, and published insights.
              </p>
            </div>

            <div className="branding-services-card">
              <div className="branding-services-icon">
                <img
                  src="/assets/Branding_icon_6.png"
                  alt="Talent Attraction Programs Icon"
                  className="branding-services-icon-img"
                
                />
              </div>
              <h3 className="branding-services-card-title">
                Talent Attraction Programs
              </h3>
              <p className="branding-services-card-desc">
                Strengthen your employer value proposition to attract high-quality candidates and build a future-ready workforce.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ===================================================
          SECTION 3: OUR RECOGNITION PROGRAMS
      =================================================== */}
      <section className="branding-recognition-section">
        <div className="branding-recognition-container">
          <h2 className="branding-recognition-heading">Our Recognition Programs</h2>
          <div className="branding-recognition-underline"></div>

          <div className="branding-recognition-grid">
            {/* LEFT — large image card with overlay */}
            <div className="branding-recognition-img-card">
              <img
                src="/assets/Branding_img_2.png"
                alt="Outstanding Workplaces Certification event"
                className="branding-recognition-img"
              />
              <div className="branding-recognition-img-overlay">
                <h3 className="branding-recognition-img-title">
                  Outstanding Workplaces Certification
                </h3>
                <p className="branding-recognition-img-desc">
                  Recognizing organizations that demonstrate excellence in workplace culture, employee engagement, leadership, diversity, innovation, and people practices.
                </p>
              </div>
            </div>

            {/* RIGHT — two stacked colour cards (blue first, then orange, per Figma) */}
            <div className="branding-recognition-right">
              <div className="branding-recognition-card branding-recognition-card-blue">
                <div className="branding-recognition-card-icon">
                  <img
                    src="/assets/Branding_icon_7.png"
                    alt="HR Excellence Awards Icon"
                    className="branding-recognition-card-icon-img"
                  />
                </div>
                <h3 className="branding-recognition-card-title">
                  HR Excellence Awards
                </h3>
                <p className="branding-recognition-card-desc">
                  Honoring organizations and HR professionals for exceptional contributions to people management and organizational success.
                </p>
              </div>

              <div className="branding-recognition-card branding-recognition-card-orange">
                <div className="branding-recognition-card-icon">
                  <img
                    src="/assets/Branding_icon_8.png"
                    alt="Leadership Recognition Icon"
                    className="branding-recognition-card-icon-img"
                  />
                </div>
                <h3 className="branding-recognition-card-title">
                  Leadership Recognition
                </h3>
                <p className="branding-recognition-card-desc">
                  Celebrating visionary CHROs, HR Leaders, People Managers, and Business Leaders driving workplace transformation.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <JoinModal isOpen={isJoinOpen} onClose={() => setIsJoinOpen(false)} />
    </>
  );
}

export default Branding;